// choices/lightChoices.js
const lightChoicesBg = [
  {
    label: "Естествена светлина",
    value: "natural",
  },
  {
    label: "Изкуствена светлина",
    value: "artificial",
  },
  {
    label: "Смесен осветление",
    value: "mixed",
  },
];

export default lightChoicesBg;
